import { drawArrow } from "./arrows";
import { frenchDoorWindow } from "./window-options/frenchDoorWindow";
import {
  WINDOW_DIMENSIONS,
  STANDARD_SPACING,
  WINDOW_COLORS,
  TEXT_SIZES
} from "../../../constants/dimensions";

export const window1 = (p5, trait, width, yurtTrait) => {
  const frenchDoorH = WINDOW_DIMENSIONS.FRENCH_DOOR_HEIGHT_INCHES * trait.pixels;
  const crippleHeight =
    yurtTrait.h - (trait.window1.windowH + trait.window1.sill) - trait.twoByW;
  const xcenter = width / 2;
  const ycenter = yurtTrait.h / 2 + STANDARD_SPACING.FIVE_INCHES * trait.pixels;
  const bottomBoard = {
    x: xcenter,
    y: ycenter + (yurtTrait.h / 2 + trait.twoByW / 2),
  };

  if (trait.window1.windowW > WINDOW_DIMENSIONS.MAX_WIDTH_INCHES * trait.pixels) {
    trait.window1.windowW = WINDOW_DIMENSIONS.MAX_WIDTH_INCHES * trait.pixels;
  }

  if (trait.frenchDoor === "left" || trait.frenchDoor === "right") {
    frenchDoorWindow(p5, trait, width, yurtTrait, "window1");
  } else {
    // jacks

    p5.push();
    p5.rectMode(p5.CENTER);
    p5.fill("lightgrey");
    p5.translate(bottomBoard.x, bottomBoard.y - trait.twoByW / 2);

    const centerWindowX = trait.window1.windowW / 2 + trait.twoByW / 2;
    const centerSillHeight =
      -trait.window1.sill / 2 - trait.window1.windowH / 2;
    const totalSillWindowHeight = trait.window1.sill + trait.window1.windowH;
    let casementWidth = 0;

    if (trait.window1.placement / trait.pixels === 1) {
      casementWidth = -(trait.w - trait.window1.windowW) / 2 + trait.twoByW * 2;
    } else if (trait.window1.placement / trait.pixels === 2) {
      casementWidth = (trait.w - trait.window1.windowW) / 2 - trait.twoByW * 2;
    }

    let sillHeight = trait.window1.sill;

    if (trait.windows > 1) {
      sillHeight =
        trait.window1.sill -
        (trait.window2.sill +
          trait.window2.windowH +
          trait.twoByW * 2 +
          trait.window2.header);
    }

    if (!trait.frenchDoor && !trait.doors) {
      if (yurtTrait.stud / trait.pixels >= 24) {
        p5.rect(
          0 + casementWidth,
          -trait.window1.sill + sillHeight / 2,
          trait.twoByW,
          sillHeight
        );
      } else {
        p5.rect(
          STANDARD_SPACING.EIGHT_INCHES * trait.pixels,
          trait.windows > 1
            ? -trait.window1.sill + sillHeight / 2 + trait.twoByW * 1.5
            : -trait.window1.sill / 2,
          trait.twoByW,
          sillHeight
        );
        p5.rect(
          -STANDARD_SPACING.EIGHT_INCHES * trait.pixels,
          trait.windows > 1
            ? -trait.window1.sill + sillHeight / 2 + trait.twoByW * 1.5
            : -trait.window1.sill / 2,
          trait.twoByW,
          sillHeight
        );
      }
    }

    if (trait.frenchDoor === "center") {
      const header = trait.frenchHeader;
      p5.rect(
        -centerWindowX + casementWidth,
        centerSillHeight - frenchDoorH / 2 - header / 2 - trait.twoByW / 4,
        trait.twoByW,
        totalSillWindowHeight - frenchDoorH - header - trait.twoByW / 2
      );
      p5.rect(
        centerWindowX + casementWidth,
        centerSillHeight - frenchDoorH / 2 - header / 2 - trait.twoByW / 4,
        trait.twoByW,
        totalSillWindowHeight - frenchDoorH - header - trait.twoByW / 2
      );
    } else if (trait.doors) {
      p5.rect(
        centerWindowX + casementWidth,
        centerSillHeight - (trait.doorH + trait.header + trait.twoByW) / 2,
        trait.twoByW,
        totalSillWindowHeight - trait.doorH - trait.header - trait.twoByW
      );
      p5.rect(
        -centerWindowX + casementWidth,
        centerSillHeight - (trait.doorH + trait.header + trait.twoByW) / 2,
        trait.twoByW,
        totalSillWindowHeight - trait.doorH - trait.header - trait.twoByW
      );
    } else if (trait.windows > 1) {
      const jackHeight =
        trait.window2.headerAmount / trait.pixels === 3
          ? centerSillHeight -
            trait.window2.sill / 2 -
            trait.window2.windowH / 2
          : centerSillHeight -
            trait.window2.sill / 2 -
            trait.window2.windowH / 2 -
            trait.window2.header / 2;
      const jackPosition =
        trait.window2.headerAmount / trait.pixels === 3
          ? totalSillWindowHeight -
            trait.window2.sill -
            trait.window2.windowH -
            trait.twoByW
          : totalSillWindowHeight -
            trait.window2.sill -
            trait.window2.windowH -
            trait.twoByW -
            trait.window2.header;
      p5.rect(
        centerWindowX + casementWidth,
        jackHeight,
        trait.twoByW,
        jackPosition
      );
      p5.rect(
        -centerWindowX + casementWidth,
        jackHeight,
        trait.twoByW,
        jackPosition
      );
    } else {
      p5.rect(
        centerWindowX + casementWidth,
        centerSillHeight,
        trait.twoByW,
        totalSillWindowHeight
      );
      p5.rect(
        -centerWindowX + casementWidth,
        centerSillHeight,
        trait.twoByW,
        totalSillWindowHeight
      );
    }

    let frenchDoorPlate = 10.5 * trait.pixels;
    if (trait.frenchW === "6ft") {
      frenchDoorPlate = 16.5 * trait.pixels;
    }

    // sill

    p5.translate(casementWidth, -trait.window1.sill + trait.twoByW);

    if (trait.window1.windowW / trait.pixels === 42) {
      p5.rect(0, 0, trait.window1.windowW + trait.twoByW * 2, trait.twoByW);
    } else {
      p5.rect(0, 0, trait.window1.windowW, trait.twoByW);
    }

    // window

    p5.translate(0, -trait.twoByW / 2 - trait.window1.windowH / 2);

    p5.fill(WINDOW_COLORS.GLASS);
    p5.rect(0, 0, trait.window1.windowW, trait.window1.windowH);

    p5.fill(WINDOW_COLORS.FRAMING);
    p5.stroke(WINDOW_COLORS.STROKE);
    p5.strokeWeight(1);

    // lintel
    p5.translate(-casementWidth, -trait.twoByW / 2 - trait.window1.windowH / 2);

    p5.rect(0, 0, trait.w - trait.twoByW * 2, trait.twoByW);

    p5.textAlign(p5.CENTER);
    p5.fill(WINDOW_COLORS.TEMPERED_TEXT);
    p5.textSize(TEXT_SIZES.MEDIUM);

    if (trait.window1.tempered === "TEMPERED") {
      p5.text(trait.window1.tempered, casementWidth, trait.window1.windowH / 3);
    }
    p5.fill(0);
    p5.text(trait.window1.windowType, casementWidth, trait.window1.windowH / 2);
    p5.fill(WINDOW_COLORS.FRAMING);

    // cripple
    p5.translate(0, -trait.twoByW / 2);
    if (!trait.frenchDoor) {
      if (yurtTrait.stud / trait.pixels >= 24) {
        p5.rect(0, -crippleHeight / 2, trait.twoByW, crippleHeight);
      } else {
        p5.rect(
          STANDARD_SPACING.EIGHT_INCHES * trait.pixels,
          -crippleHeight / 2,
          trait.twoByW,
          crippleHeight
        );
        p5.rect(
          -STANDARD_SPACING.EIGHT_INCHES * trait.pixels,
          -crippleHeight / 2,
          trait.twoByW,
          crippleHeight
        );
      }
    }

    // header
    p5.translate(0, -trait.window1.header / 2);

    if (trait.window1.headerAmount / trait.pixels !== 3) {
      if (
        trait.frenchDoor === "left" &&
        trait.window1.windowH + trait.window1.sill <
          frenchDoorH + trait.frenchHeader + trait.twoByW * 2
      ) {
        p5.rect(
          0 - frenchDoorPlate / 2,
          0,
          trait.w - frenchDoorPlate - trait.twoByW * 2,
          trait.window1.header
        );
      } else if (
        trait.frenchDoor === "right" &&
        trait.window1.windowH + trait.window1.sill + trait.window1.header <
          frenchDoorH + trait.frenchHeader + trait.twoByW * 2
      ) {
        p5.rect(
          0 + frenchDoorPlate / 2,
          0,
          trait.w - frenchDoorPlate - trait.twoByW * 2,
          trait.window1.header
        );
      } else {
        p5.rect(0, 0, trait.w - trait.twoByW * 2, trait.window1.header);
      }

      p5.textAlign(p5.CENTER, p5.CENTER);
      p5.fill(0);
      p5.textSize(TEXT_SIZES.SMALL / trait.pixels);
      p5.strokeWeight(0);
      p5.text(
        `2 x ${Math.ceil(trait.window1.header / trait.pixels)}`,
        casementWidth,
        40 / trait.pixels
      );
      const headerTypes = ["SINGLE", "DOUBLE", "TRIPLE"];
      p5.text(
        `${headerTypes[trait.window1.headerAmount / trait.pixels]} HEADER`,
        casementWidth,
        -40 / trait.pixels
      );
    }
    // p5.textStyle(p5.BOLD)
    // p5.fill("red")
    // p5.text(trait.window1.headerType === "LVL" ? "LVL" : null, casementWidth + trait.w/7, 40/trait.pixels);

    p5.pop();

    if (trait.windows <= 1) {
      // sill height arrows
      let outerBottom = p5.createVector(
        bottomBoard.x + STANDARD_SPACING.FIVE_INCHES * trait.pixels + casementWidth,
        bottomBoard.y + trait.twoByW / 2
      );
      let outerSill = p5.createVector(
        0,
        -trait.window1.sill - trait.twoByW / 2
      );

      if (trait.frenchDoor === "center") {
        outerBottom = p5.createVector(
          bottomBoard.x + STANDARD_SPACING.FIVE_INCHES * trait.pixels + casementWidth,
          bottomBoard.y - frenchDoorH - trait.frenchHeader
        );
        outerSill = p5.createVector(
          0,
          -trait.window1.sill -
            trait.twoByW +
            frenchDoorH +
            trait.frenchHeader +
            trait.twoByW
        );
        drawArrow(
          p5,
          outerBottom,
          outerSill,
          trait.window1.sill - frenchDoorH - trait.frenchHeader - trait.twoByW,
          trait.pixels
        );
      } else if (trait.doors) {
      } else {
        drawArrow(p5, outerBottom, outerSill, trait.window1.sill, trait.pixels);
      }

      // sill inner height arrows
      let innerBottom = p5.createVector(
        bottomBoard.x - STANDARD_SPACING.FIVE_INCHES * trait.pixels + casementWidth,
        bottomBoard.y - trait.twoByW / 3
      );
      let innerSill = p5.createVector(0, -trait.window1.sill + trait.twoByW);
      if (trait.frenchDoor === "center") {
        innerBottom = p5.createVector(
          bottomBoard.x - STANDARD_SPACING.FIVE_INCHES * trait.pixels + casementWidth,
          bottomBoard.y - trait.twoByW - frenchDoorH - trait.frenchHeader
        );
        innerSill = p5.createVector(
          0,
          -trait.window1.sill +
            trait.twoByW +
            frenchDoorH +
            trait.frenchHeader +
            trait.twoByW
        );
        drawArrow(
          p5,
          innerBottom,
          innerSill,
          trait.window1.sill -
            trait.twoByW * 3 -
            frenchDoorH -
            trait.frenchHeader,
          trait.pixels
        );
      } else if (trait.doors) {
        innerBottom = p5.createVector(
          bottomBoard.x - STANDARD_SPACING.FIVE_INCHES * trait.pixels + casementWidth,
          bottomBoard.y - trait.doorH - trait.twoByW * 1.5
        );
        innerSill = p5.createVector(
          0,
          -trait.window1.sill + trait.twoByW * 1.5 + trait.doorH
        );
        drawArrow(
          p5,
          innerBottom,
          innerSill,
          trait.window1.sill - trait.twoByW * 3 - trait.doorH,
          trait.pixels
        );
      } else {
        if (trait.window1.sill - trait.twoByW * 2 > 0) {
          drawArrow(
            p5,
            innerBottom,
            innerSill,
            trait.window1.sill - trait.twoByW * 2,
            trait.pixels
          );
        }
      }
    } else {
      let outerBottom = p5.createVector(
        bottomBoard.x + STANDARD_SPACING.FIVE_INCHES * trait.pixels + casementWidth,
        bottomBoard.y - trait.window2.sill - trait.window2.windowH
      );
      let outerSill = p5.createVector(
        0,
        trait.window2.sill + trait.window2.windowH - trait.window1.sill
      );
      let innerBottom = p5.createVector(
        bottomBoard.x - STANDARD_SPACING.FIVE_INCHES * trait.pixels + casementWidth,
        bottomBoard.y -
          trait.window2.sill -
          trait.window2.windowH -
          trait.twoByW
      );
      let innerSill = p5.createVector(
        0,
        trait.window2.sill +
          trait.window2.windowH -
          trait.window1.sill +
          trait.twoByW * 2
      );
      // outer sill, two windows, jack arrows
      drawArrow(
        p5,
        outerBottom,
        outerSill,
        trait.window1.sill - trait.window2.sill - trait.window2.windowH,
        trait.pixels
      );
      // inner sill, two windows, jack arrows
      drawArrow(
        p5,
        innerBottom,
        innerSill,
        -(trait.window2.sill + trait.window2.windowH + trait.twoByW * 2) +
          trait.window1.sill,
        trait.pixels
      );
    }

    // cripple arrow

    const lintel =
      bottomBoard.y - trait.window1.windowH - trait.window1.sill - trait.twoByW;
    let crippleArrow0 = p5.createVector(xcenter - STANDARD_SPACING.FIFTEEN_INCHES * trait.pixels, lintel);
    let crippleArrow1 = p5.createVector(0, -crippleHeight);
    drawArrow(
      p5,
      crippleArrow0,
      crippleArrow1,
      yurtTrait.h -
        (trait.window1.windowH + trait.window1.sill) -
        trait.twoByW * 3,
      trait.pixels
    );

    let windowArrowH0 = p5.createVector(
      xcenter + casementWidth - trait.window1.windowW / 4,
      lintel + trait.window1.windowH + trait.twoByW
    );
    let windowArrowH1 = p5.createVector(0, -trait.window1.windowH);

    drawArrow(
      p5,
      windowArrowH0,
      windowArrowH1,
      trait.window1.windowH,
      trait.pixels
    );

    let windowArrowW0 = p5.createVector(
      xcenter + casementWidth - trait.window1.windowW / 2,
      lintel + trait.window1.windowH + trait.twoByW - STANDARD_SPACING.TEN_INCHES * trait.pixels
    );
    let windowArrowW1 = p5.createVector(trait.window1.windowW, 0);

    drawArrow(
      p5,
      windowArrowW0,
      windowArrowW1,
      trait.window1.windowW,
      trait.pixels
    );

    if (trait.window1.windowW / trait.pixels < WINDOW_DIMENSIONS.MAX_WIDTH_INCHES) {
      if (trait.frenchDoor === "center") {
        let windowJack1 = p5.createVector(
          bottomBoard.x + trait.window1.windowW / 2,
          lintel
        );
        let windowJack2 = p5.createVector(
          0,
          trait.window1.windowH +
            (trait.h - frenchDoorH) / 2 -
            trait.header / 2 +
            trait.twoByW / 2
        );

        drawArrow(
          p5,
          windowJack1,
          windowJack2,
          trait.window1.windowH +
            trait.window1.sill -
            frenchDoorH -
            trait.frenchHeader -
            trait.twoByW,
          trait.pixels
        );
      } else if (trait.frenchDoor === "left" || trait.frenchDoor === "right") {
        let windowJack1 = p5.createVector(bottomBoard.x, lintel);
        let windowJack2 = p5.createVector(
          0,
          trait.window1.windowH + trait.window1.sill + trait.twoByW / 2
        );
        drawArrow(
          p5,
          windowJack1,
          windowJack2,
          trait.window1.windowH + trait.window1.sill,
          trait.pixels
        );
      } else {
        if (trait.windows > 1) {
          let windowJack1 = p5.createVector(
            bottomBoard.x + trait.window1.windowW / 2,
            lintel + trait.twoByW
          );
          let windowJack2 = p5.createVector(
            0,
            trait.window1.windowH +
              trait.window1.sill -
              trait.window2.sill -
              trait.window2.windowH -
              trait.twoByW
          );
          drawArrow(
            p5,
            windowJack1,
            windowJack2,
            trait.window1.windowH +
              trait.window1.sill -
              trait.window2.sill -
              trait.window2.windowH -
              trait.twoByW,
            trait.pixels
          );
        } else if (trait.doors) {
          let windowJack1 = p5.createVector(
            bottomBoard.x + trait.window1.windowW / 2,
            lintel
          );
          let windowJack2 = p5.createVector(
            0,
            trait.window1.windowH +
              trait.window1.sill +
              trait.twoByW / 2 -
              trait.doorH -
              trait.twoByW
          );
          drawArrow(
            p5,
            windowJack1,
            windowJack2,
            trait.window1.windowH +
              trait.window1.sill -
              trait.doorH -
              trait.twoByW * 2,
            trait.pixels
          );
        } else {
          let windowJack1 = p5.createVector(
            bottomBoard.x + trait.window1.windowW / 2,
            lintel + trait.twoByW
          );
          let windowJack2 = p5.createVector(
            0,
            trait.window1.windowH + trait.window1.sill
          );
          drawArrow(
            p5,
            windowJack1,
            windowJack2,
            trait.window1.windowH + trait.window1.sill - trait.twoByW,
            trait.pixels
          );
        }
      }
    }
    return {
      x: xcenter + casementWidth,
      y: bottomBoard.y - trait.window1.windowH / 2 - trait.window1.sill,
    };
  }
};
